module.exports = __webpack_public_path__ + "img/PLDT_logo@2x.8f85fb5b.png";